import { render, staticRenderFns } from "./Corporate.html?vue&type=template&id=930ffcc6&external"
import script from "./Corporate.js?vue&type=script&lang=js&external"
export * from "./Corporate.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports